;(function () {
  angular.module('contrast.templates').factory('csTemplates', csTemplates)

  function csTemplates($templateRequest, $interpolate, $q, _) {
    'ngInject'

    var service = {
      loadAndInterpolate: loadAndInterpolate,
      load: load,
      interpolate: interpolate
    }

    function loadAndInterpolate(templateUrl, opts) {
      if (!angular.isString(templateUrl)) {
        throw new Error('1st arg must be a valid template url string')
      }
      if (!angular.isObject(opts)) {
        opts = {}
      }
      return $templateRequest(templateUrl).then(function (template) {
        opts = _.mapValues(opts, function (val) {
          return _.escape(val)
        })
        var fn = $interpolate(template)
        return opts ? fn(opts) : fn()
      })
    }

    function load(templateUrl) {
      if (!angular.isString(templateUrl)) {
        return $q.reject('1st arg must be a valid template url string')
      }
      return $templateRequest(templateUrl).then(function (template) {
        return template
      })
    }

    function interpolate(template, opts) {
      opts = _.mapValues(opts, function (val) {
        return _.escape(val)
      })
      var fn = $interpolate(template)
      return opts ? fn(opts) : fn()
    }

    return service
  }
}).call(this)
